import { render, staticRenderFns } from "./upgradePkgsPopup.vue?vue&type=template&id=1160cdcb&scoped=true&"
import script from "./upgradePkgsPopup.vue?vue&type=script&lang=js&"
export * from "./upgradePkgsPopup.vue?vue&type=script&lang=js&"
import style0 from "./upgradePkgsPopup.vue?vue&type=style&index=0&id=1160cdcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1160cdcb",
  null
  
)

export default component.exports